import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const flatButton = {
  lineHeight: "24px",
  borderRadius: 24,
  padding: "0 24px",
  paddingLeft: 8,
  paddingTop: 8,
  paddingBottom: 8,
  color: greys.slate,
} as CSSProperties;

export const flatButtonIcon = {
  marginRight: spacing.std,
  paddingBottom: 2,
};

export const primaryButton = {
  border: "none",
  borderRadius: 24,
  lineHeight: "24px",
  padding: "0 24px",
  paddingRight: 8,
  paddingTop: 8,
  paddingBottom: 6,
  boxShadow: "none",
} as CSSProperties;

export const primaryButtonIcon = {
  marginLeft: spacing.std,
  paddingBottom: 2,
};
